












import Icon from "./Icon.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    Icon,
  },
})
export default class SocialMedia extends Vue {}
